<template>
  <div class="filter-block__group">
    <div class="filter-block__text">{{ field.label }}</div>
    <vue-slider
      ref="slider"
      v-model="fieldValue"
      :tooltip="false"
      :dot-size="18"
      :height="3"
      :process-style="{
        backgroundColor: '#f95c4e',
      }"
      :min="field.min"
      :max="field.max"
      class="ui-slider"
      style="padding: 0"
    />
    <input v-model.number="fieldValue" type="number" class="form-control" />
  </div>
</template>

<script>
import { FieldMixin } from "stylemix-base";
import vueSlider from "vue-slider-component";

export default {
  name: "FormLocationRadiusField",

  components: {
    vueSlider,
  },

  mixins: [FieldMixin],

  watch: {
    fieldValue(v) {
      this.$store.commit("setLocationRadius", v);
    },
  },

  mounted() {
    if (this.model && this.model.location_radius)
      this.$store.commit("setLocationRadius", this.model.location_radius);
  },

  methods: {},
};
</script>

<style>
.ui-slider {
  margin-bottom: 20px;
}
</style>
